import settings_tariff_assignment_methods from "@/components/Settings/settings_tariff_assignment_methods";

const active_property_storage_key = "bolide_active_property_context";

export default {
    ...settings_tariff_assignment_methods,

    handle_resize() {
        this.is_mobile = window.innerWidth < 768;
        if (!this.is_mobile) this.mobile_sidebar_open = false;
    },

    toggle_mobile_sidebar() {
        this.mobile_sidebar_open = !this.mobile_sidebar_open;
    },

    clear_snackbar_timer() {
        if (this.snackbar_timeout_id) {
            clearTimeout(this.snackbar_timeout_id);
            this.snackbar_timeout_id = null;
        }
    },

    start_snackbar_timer() {
        this.clear_snackbar_timer();
        this.snackbar_timeout_id = setTimeout(() => {
            this.load_error = "";
            this.save_success = "";
            this.snackbar_timeout_id = null;
        }, 5000);
    },

    clear_load_error() {
        this.clear_snackbar_timer();
        this.load_error = "";
    },

    clear_save_success() {
        this.clear_snackbar_timer();
        this.save_success = "";
    },

    set_load_error(message) {
        this.load_error = message || "";
        if (message) {
            this.save_success = "";
            this.start_snackbar_timer();
        }
    },

    set_save_success(message) {
        this.save_success = message || "";
        if (message) {
            this.load_error = "";
            this.start_snackbar_timer();
        }
    },

    handleBreadcrumbClick(id) {
        if (id === "home") {
            this.$router.push("/home");
        }
    },

    get_active_property_context() {
        return JSON.parse(sessionStorage.getItem(active_property_storage_key) || "null");
    },

    set_active_settings_tab(tab_id) {
        this.active_settings_tab = tab_id;
    },

    open_add_tariff_modal() {
        const active_property_id = this.active_settings_property_id;
        this.selected_assignment_id = null;
        this.is_property_locked = Boolean(active_property_id);
        this.form_error = "";
        this.reset_new_tariff_form();
        this.new_tariff.property_id = active_property_id;
        this.show_add_tariff_modal = true;
    },

    open_tariff_rates_modal(row) {
        if (!row?.tariff_book_id) {
            return;
        }

        const matching_tariff_book = this.tariff_books.find((tariff_book) => tariff_book.id === row.tariff_book_id) || null;
        this.selected_tariff_book = matching_tariff_book;
        this.selected_tariff_context = row;
        this.show_tariff_rates_modal = true;
    },

    open_tariff_book_rates_modal(payload) {
        const tariff_book = this.get_tariff_book_from_payload(payload);

        if (!tariff_book?.id) {
            return;
        }

        this.selected_tariff_book = tariff_book;
        this.selected_tariff_context = payload?.context || null;
        this.selected_tariff_rates_tab = payload?.tab || "view";
        this.show_tariff_rates_modal = true;
    },

    get_tariff_book_from_payload(payload) {
        return payload?.tariff_book || payload;
    },

    close_tariff_rates_modal() {
        this.show_tariff_rates_modal = false;
        this.selected_tariff_book = null;
        this.selected_tariff_context = null;
        this.selected_tariff_rates_tab = "view";
    },

    async handle_tariff_rates_updated(message) {
        this.close_tariff_rates_modal();
        await this.load_tariff_settings_data();
        this.set_save_success(message || "Tariff rates updated successfully.");
    },

    close_add_tariff_modal() {
        this.show_add_tariff_modal = false;
        this.selected_assignment_id = null;
        this.is_property_locked = false;
        this.form_error = "";
        this.reset_new_tariff_form();
    },

    update_new_tariff_form(next_form_state) {
        this.new_tariff = {
            ...this.new_tariff,
            ...next_form_state
        };
    },

    reset_new_tariff_form() {
        this.new_tariff = this.create_tariff_form();
    },

};
